import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const CODES = 'codes'
export const CANCEL = 'cancel'
export const SAVE = 'save'
export const ENTER_THE_CODES = 'enter-the-codes'
export const ENTER_THE_LABELS = 'enter-the-labels'
export const TEXT = 'text'
export const INSTRUCTION = 'instruction'
export const TITLE = 'TITLE__'

export default {
  [PORTUGUESE]: {
    [CODES]: 'Códigos',
    [TEXT]: 'Texto de Resposta',
    [CANCEL]: 'Cancelar',
    [SAVE]: 'Salvar',
    [ENTER_THE_CODES]: 'Insira os códigos que deseja adicionar',
    [ENTER_THE_LABELS]: 'Insira os textos de respostas que deseja adicionar',
    [INSTRUCTION]: 'Cada opção deve estar em linhas individuais',
    [TITLE]: 'Edição em massa',
  },

  [ENGLISH]: {
    [CODES]: 'Codes',
    [TEXT]: 'Answer Text',
    [CANCEL]: 'Cancel',
    [SAVE]: 'Save',
    [ENTER_THE_CODES]: 'Enter the codes you want to add',
    [ENTER_THE_LABELS]: 'Enter the response texts you want to add',
    [INSTRUCTION]: 'Each option must be on individual lines',
    [TITLE]: 'Bulk edit alternatives',
  },

  [SPANISH]: {
    [CODES]: 'Códigos',
    [TEXT]: 'Texto de Respuesta',
    [CANCEL]: 'Cancelar',
    [SAVE]: 'Ahorrar',
    [ENTER_THE_CODES]: 'Introduce los códigos que quieras añadir',
    [ENTER_THE_LABELS]: 'Introduce los textos de respuesta que desea agregar',
    [INSTRUCTION]: 'Cada opción debe estar en líneas individuales',
    [TITLE]: 'Edição em massa',
  },
}
